import { render } from "./WillkommenView.vue?vue&type=template&id=333a2708"
import script from "./WillkommenView.vue?vue&type=script&lang=js"
export * from "./WillkommenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__